'use client';
import React, { useState, useEffect } from 'react'
import { useSwipeable } from 'react-swipeable';


interface CarouselProps {
    items: number;
    itemsMobile: number;
    children: any;
    bullets?: boolean;
    activeIndex: number;
    updateIndex: (index: number) => void;
}

interface CarouselItemProps {
    children: any;
    width: string;
    className: string;
}

export const CarouselItem = (props: CarouselItemProps) => {
    return (
        <div className={props.className} style={{ width: props.width }}>
            {props.children}
        </div>
    );
};

const Carousel = (props: CarouselProps) => {
    const { activeIndex, updateIndex } = props;
    const [itemsPerView, setItemsPerView] = useState(props.items);
    const [itemsPerViewMobile, setItemsPerViewMobile] = useState(props.itemsMobile);
    const [dekstopItemsPercentage, setDekstopItemsPercentage] = useState(0);
    const [totalItems, setTotalItems] = useState(React.Children.count(props.children));
    const [screen, setScreen] = useState('D'); // D: Desktop, M: Mobile
    const [bullets, setBullets] = useState(props.bullets || false);

    useEffect(() => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 768) {
            setDekstopItemsPercentage(100 / itemsPerViewMobile);
            setScreen('M');
        } else {
            setDekstopItemsPercentage(100 / itemsPerView);
            setScreen('D');
        }
    }, [itemsPerView, itemsPerViewMobile]);

    const swipeable = useSwipeable({
        onSwipedLeft: () => updateIndex(activeIndex + 1),
        onSwipedRight: () => updateIndex(activeIndex - 1),
    });

    return (
        <div className='carouselContainer'>
            <div className='carousel' {...swipeable}>
                <div className='carousel__inner' style={{ transform: `translateX(-${activeIndex * (dekstopItemsPercentage)}%)` }}>
                    {React.Children.map(props.children, (child, index) => {
                        return React.cloneElement(child, { width: `${dekstopItemsPercentage}%`, className: `carousel__item` });
                    })}
                </div>
            </div>

            { bullets && React.Children.count(props.children) > 1 &&
                <div className="flex justify-center gap-2">
                    {Array.from({ length: totalItems }, (_, i) => i).map((index) => {
                        return <button key={index} className={`rounded-full h-2 w-2 ${activeIndex === index ? 'bg-gray-400' : 'bg-gray-300'}`} onClick={() => updateIndex(index)}></button>
                    })}
                </div>
            }
        </div>
    );
};

export default Carousel;